export function LanguageSwitcherSkeleton() {
  return (
    <>
      {/* Mobile: matches the real DE / EN links */}
      <div className="relative block lg:hidden">
        <span className="relative overflow-hidden pb-12">DE</span>
        {' / '}
        <span className="relative overflow-hidden pb-12">EN</span>
      </div>
      {/* Desktop: matches the real Menu.Trigger button */}
      <div className="hidden lg:flex items-center gap-x-6">
        DE
        <svg
          width="9"
          height="6"
          viewBox="0 0 9 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 0H0L4.5 6L9 0Z" fill="black" />
        </svg>
      </div>
    </>
  )
}
